import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PATHS from '~/app/utils/paths';
import loadable from '@loadable/component';

const FFRobotBusinessCompanyInfoPage = loadable(() => import(/* webpackChunkName: "FFRobotBusinessCompanyInfoPage" */ '~/app/pages/FFRobotBusinessPage/CompanyInfo/FFRobotBusinessCompanyInfoPage'));
const FFRobotBusinessPreorderPage = loadable(() => import(/* webpackChunkName: "FFRobotBusinessPreorderPage" */ '~/app/pages/FFRobotBusinessPage/FFRobotBusinessPreorder/FFRobotBusinessPreorder'));
const FFRobotBusinessDashboardPage = loadable(() => import(/* webpackChunkName: "FFRobotBusinessDashboardPage" */ '~/app/pages/FFRobotBusinessPage/Dashboard/FFRobotBusinessDashboardPage'));

const FFRobotBusinessRouter = () => (
  <Switch>
    <Route exact path={`/:locale(us)${PATHS.FF_ROBOT_BUSINESS_COMPANY_INFO}`} component={FFRobotBusinessCompanyInfoPage} />
    <Route exact path={`/:locale(us)${PATHS.FF_ROBOT_BUSINESS_PREORDER}`} component={FFRobotBusinessPreorderPage} />
    <Route exact path={`/:locale(us)${PATHS.FF_ROBOT_BUSINESS_DASHBOARD}`} component={FFRobotBusinessDashboardPage} />
    <Route exact path={`/:locale(us)${PATHS.FF_ROBOT_BUSINESS_ORDER_DETAILS}`} component={FFRobotBusinessDashboardPage} />
    <Route exact path={`/:locale(us)${PATHS.FF_ROBOT_BUSINESS_DASHBOARD}/:section`} component={FFRobotBusinessDashboardPage} />
    <Route exact path={`/:locale(us)${PATHS.FF_ROBOT_BUSINESS}`}>
      <Redirect to={`/us${PATHS.FF_ROBOT_BUSINESS_LOGIN}`} />
    </Route>
    <Redirect to={`/us${PATHS.FF_ROBOT_BUSINESS_LOGIN}`} />
  </Switch>
);

export default FFRobotBusinessRouter;
